export default {
  en: {
    title: 'Create a ClassForKids System',
  },
  fr: {
    title: 'Essayer ClassForKids',
  },
};
